import React from 'react';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error('Prompt engine crash:', error);
  }

  render() {
    if (this.state.hasError) {
      return <div className="p-4 text-sm">Engine Error</div>;
    }

    return this.props.children;
  }
}
